<script>
  import Icon from '../Icon/Icon.svelte';
  export let href = null,
    target = null,
    noScroll = false,
    center = false,
    arrow = null,
    thin = null,
    rel = null,
    testid = null,
    collectid = null;
</script>

<style lang="scss">
  @import '../../styles/settings/core';
  @import '../../styles/settings/colors';

  .text-button {
    display: flex;
    align-items: center;
    padding: 0;
    padding-block-start: spacing(1.5);
    fill: $orange-50;
    color: $orange-50;
    font-weight: 600;
    cursor: pointer;

    &.thin {
      font-weight: 400;
    }

    &:hover {
      color: $orange-60;
      fill: $orange-60;
    }

    &:active {
      color: $orange-70;
      fill: $orange-70;
    }

    &.center {
      justify-content: center;
    }
  }

  .button-link {
    text-decoration: none;
    color: $orange-50;
    cursor: pointer;

    &:hover {
      color: $orange-60;
      fill: $orange-60;
    }

    &:active {
      color: $orange-70;
      fill: $orange-70;
    }

    &:disabled {
      opacity: 0.5;
      cursor: default;
    }
  }

  .inlineEnd-padding {
    padding-inline-start: 0;
    padding-inline-end: spacing(0.5);
  }

  .inlineStart-padding {
    padding-inline-start: spacing(0.5);
    padding-inline-end: 0;
  }
</style>

<div class="text-button" class:center class:thin on:click>
  {#if arrow === 'inlineStart'}
    <Icon inlineStart iconName="angle" rtlFlip />
  {/if}
  <span class="{arrow}-padding">
    {#if href}
      <a
        class="button-link"
        {href}
        {target}
        {rel}
        sapper-noscroll={noScroll}
        data-testid={testid}
        data-collectid={collectid}
      >
        <slot />
      </a>
    {:else}
      <slot />
    {/if}
  </span>
  {#if arrow === 'inlineEnd'}
    <Icon iconName="angle" rtlFlip />
  {/if}
  {#if arrow === 'blockStart'}
    <Icon iconName="angle" blockStart />
  {/if}
  {#if arrow === 'blockEnd'}
    <Icon iconName="angle" blockEnd />
  {/if}
</div>
